"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicroTimer = void 0;
exports.convertMillisecondToTimeString = convertMillisecondToTimeString;
var _utilities = require("./utilities");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const {
  isClient,
  isNode
} = (0, _utilities.determineEnvironment)();
class MicroTimer {
  constructor() {
    _defineProperty(this, "startTime", 0);
    this.start();
  }
  start() {
    this.startTime = this.getTime();
    return this;
  }
  elapsedTime() {
    const elapsed = this.getTime(this.startTime);
    if (isClient) {
      return elapsed;
    }
    if (isNode) {
      return Math.round(elapsed[0] * 1000 + elapsed[1] / 1000000);
    }
    return -1;
  }
  elapsedTimeAsString() {
    return convertMillisecondToTimeString(this.elapsedTime());
  }
  getTime(from) {
    if (isClient) {
      return window.performance.now() - (from ?? 0);
    } else if (isNode) {
      return process.hrtime(from);
    }
    return 0;
  }
}
exports.MicroTimer = MicroTimer;
const oneSecondInMs = 1000;
const oneMinuteInMs = 60 * oneSecondInMs;
const oneHourInMs = 60 * oneMinuteInMs;
function convertMillisecondToTimeString(timeInMs) {
  const time = timeInMs;
  if (time >= oneSecondInMs) {
    if (time >= oneHourInMs) {
      const rem = time % oneHourInMs;
      const hours = (time - rem) / oneHourInMs;
      const mins = convertMillisecondToTimeString(Math.round(rem / oneMinuteInMs) * oneMinuteInMs);
      return `${hours}h${mins}`;
    } else if (time >= oneMinuteInMs) {
      const rem = time % oneMinuteInMs;
      const mins = (time - rem) / oneMinuteInMs;
      const ms = convertMillisecondToTimeString(Math.round(rem / oneSecondInMs) * oneSecondInMs);
      return `${mins}m${ms !== '0ms' ? ms : ''}`;
    } else {
      return Math.round(time) / 1000.0 + 's';
    }
  }
  let timeString = String(time);
  const ix = timeString.indexOf('.');
  if (ix > 0) {
    timeString = timeString.substring(0, ix + 4);
  }
  return timeString + 'ms';
}